import React from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
// Check for localStorage availability
const checkStorage = () => {
  try {
    const test = '__storage_test__';
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-1136">
    <ErrorBoundary data-id="element-1137">
      {!checkStorage() ? <div className="min-h-screen bg-white flex items-center justify-center p-4" data-id="element-1138">
          <div className="text-center" data-id="element-1139">
            <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-1140">
              Lagring inte tillgänglig
            </h1>
            <p className="text-gray-600" data-id="element-1141">
              Din webbläsare har begränsad åtkomst till lokal lagring. Detta kan
              bero på privat surfläge eller cookie-inställningar.
            </p>
          </div>
        </div> : <App data-id="element-1142" />}
    </ErrorBoundary>
  </React.StrictMode>);